export function debuglog(message?: any, ...optionalParams: any[]) {
  if (process.env.NODE_ENV === "development") {
    console.debug(message, ...optionalParams);
  }
}
